import {
    Box, Text,
    Flex, Heading,
    Image,
    Button
} from "@chakra-ui/react";
import { React, useEffect, useState } from 'react';
import img6 from "../../../../assets/images/img-6.png";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../../../config";
import NoCover from "../NoCover/NoCover";
import moment from 'moment';
import { useTranslation } from "react-i18next";
import FavoriteButton from "../../pages/AllEventsPage/FavoriteButton";

const Event = ({ event, color = '#6E6064', titleColor = '#1E1517', onFavoriteToggle, isSuperAdmin }) => {

    const navigate = useNavigate();
    const { t } = useTranslation("default");
    const baseURL = BASE_URL;

    const formattedDate = (date) => {
        return moment(date).format('DD.MM.YYYY');
    };

    const getImg = (event) => {
        const path = event?.coverImage;
        return path ? `${baseURL}/${path}` : img6;
    }

    const handleNavigate = (route, options = {}) => {
        navigate(route, options);
    };

    const handleShowDetails = (event) => {
        handleNavigate(`/event/${event.id}`, { state: { event } });
    };

    return (
        <Box
            key={event.id}
            boxShadow="none"
            rounded="12px"
            display="flex"
            flexDirection="column"
            height="100%"
            gap={'8px'}
            pb={'32px'}
            onClick={() => handleShowDetails(event)}
        >
            <Box position="relative" role="group" cursor={"pointer"}>
                <Box h="171px" flexShrink={0} borderRadius={'8px'} overflow="hidden">
                    {event.coverImage ? (
                        <Image src={getImg(event)} alt={event.title} objectFit="contain" bg="#F8ECEF"
                            w="100%" maxW={{ base: '100%', md: '304px' }}
                            aspectRatio="16 / 9" h="auto" borderRadius={'8px'} />
                    ) : (
                        <Box w="100%" maxW={{ base: '100%', md: '304px' }} aspectRatio="16 / 9" borderRadius="8px" overflow="hidden"><NoCover size="100%" h="100%" minH={0} /></Box>
                    )}
                    {/* Overlay */}
                    {(event.isFree || (event.ticketTypes && event.ticketTypes.length > 0)) && (
                        <Box
                            position="absolute"
                            top="0"
                            left="0"
                            width="100%"
                            height="100%"
                            backgroundColor="rgba(0, 0, 0, 0.4)"
                            opacity="0"
                            transition="opacity 0.3s ease"
                            _groupHover={{ opacity: '1' }}
                            display="flex"
                            flexDirection="column"
                            justifyContent="space-between"
                            p="12px"
                            borderRadius={'8px'}
                        >
                            {/* Serduszko */}
                            <Flex justifyContent="flex-end" onClick={(e) => e.stopPropagation()}>
                                <FavoriteButton eventId={event.id} isFavorite={event.isFavorite} onChange={onFavoriteToggle} />
                            </Flex>

                            {/* Przycisk */}
                            <Button
                                w="100%"
                                bg="#7A1F35"
                                color="white"
                                borderRadius={'12px'}
                                fontWeight="400"
                                fontSize="18px"
                                _hover={{ bg: "#5C1628" }}
                                gap={'10px'}
                            >
                                <Text>
                                    {t('details')}
                                </Text>
                            </Button>
                        </Box>
                    )}
                </Box>

            </Box>
            <Box>
                <Button bg={'#7A1F35'} color={'#FFFFFF'} my={'0px'} borderRadius={'12px'} w='100%'
                    fontFamily="body" fontWeight={'500'} fontSize='14px' cursor="default">
                    {!event.isFree &&
                        <svg width="21" height="17" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.5 1.5V3.5M13.5 7.5V9.5M13.5 13.5V15.5M3.5 1.5C2.96957 1.5 2.46086 1.71071 2.08579 2.08579C1.71071 2.46086 1.5 2.96957 1.5 3.5V6.5C2.03043 6.5 2.53914 6.71071 2.91421 7.08579C3.28929 7.46086 3.5 7.96957 3.5 8.5C3.5 9.03043 3.28929 9.53914 2.91421 9.91421C2.53914 10.2893 2.03043 10.5 1.5 10.5V13.5C1.5 14.0304 1.71071 14.5391 2.08579 14.9142C2.46086 15.2893 2.96957 15.5 3.5 15.5H17.5C18.0304 15.5 18.5391 15.2893 18.9142 14.9142C19.2893 14.5391 19.5 14.0304 19.5 13.5V10.5C18.9696 10.5 18.4609 10.2893 18.0858 9.91421C17.7107 9.53914 17.5 9.03043 17.5 8.5C17.5 7.96957 17.7107 7.46086 18.0858 7.08579C18.4609 6.71071 18.9696 6.5 19.5 6.5V3.5C19.5 2.96957 19.2893 2.46086 18.9142 2.08579C18.5391 1.71071 18.0304 1.5 17.5 1.5H3.5Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    }
                    <Text px={'4px'} py={'12px'}>
                        {t(event.isFree ? 'event.ticket.free' : 'tickets')}
                    </Text>
                </Button>
            </Box>

            <Flex flex="1" direction="column" justifyContent="space-between" minW='100%' h="317px">
                <Flex flexDirection="column" gap={'4px'} color={color} h={"auto"} justifyContent="space-between">
                    <Flex gap={'8px'} alignItems={"center"} fontFamily="body" fontWeight={'500'} fontSize='14px' flexWrap={"wrap"}>
                        {event.categories.map((category, index) => (
                            <Flex key={index} alignItems="center">
                                <Text>
                                    {category}
                                </Text>
                                {index < event.categories.length - 1 && (
                                    <Box mx={'4px'}>
                                        <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="2.55032" y="-0.050293" width="3.60669" height="3.60669" rx="1" transform="rotate(45 2.55032 -0.050293)" fill="#6E6064" />
                                        </svg>
                                    </Box>
                                )}
                            </Flex>
                        ))}
                    </Flex>
                    <Flex flexDirection={"column"} gap={'12px'}>
                        <Heading fontFamily="body" fontWeight={'700'} fontSize={{ base: '16px', md: '18px' }} color={titleColor}>
                            {event.title}
                        </Heading>
                    </Flex>
                    <Flex justifyContent={"space-between"} flexDirection="column" gap='4px'
                        fontFamily="body" fontWeight={'500'} fontSize='14px'
                    >
                        <Text>
                            {event.address}
                        </Text>
                        <Text>
                            {formattedDate(event.startDate)}
                        </Text>
                        {isSuperAdmin && event.authorFullName && (
                            <Text fontFamily="body" fontWeight={'400'} fontSize={'14px'} color={color || '#6E6064'}>
                                Autor: {event.authorFullName}
                            </Text>
                        )}
                    </Flex>
                </Flex>
            </Flex>
        </Box>
    );
}

export default Event;
